import React from "react";
import { Input, Select } from "semantic-ui-react";

const SelectOperator = (props) => {
  const { operators, value, onChange, fluid } = props;
  if (operators.length === 1) {
    return (
      <Input
        readOnly
        className={props.className}
        fluid={fluid}
        value={operators[0].text}
        style={props.style}
      />
    );
  }
  return (
    <Select
      search
      className={props.className}
      {...(fluid ? { fluid: true } : {})}
      name="selectedOperator"
      options={operators}
      value={value}
      placeholder={props.placeholder}
      onChange={onChange}
      style={props.style}
    />
  );
};

export default SelectOperator;
